import Splide from '@splidejs/splide';
import { isMobileScreen } from './utils';
import { BREAKPOINTS } from './constants';

const onCardsModuleLoad = () => {

  const cardsModule = document.getElementsByClassName('cards-module');

  if (!cardsModule) return;

  Array.from(cardsModule)?.forEach((item) => {

    const draggable = isMobileScreen(BREAKPOINTS.XXL) || item?.getElementsByTagName('li')?.length > 4;
    if (!draggable) item.getElementsByClassName('cards-module_arrows-container')?.[0]?.classList.add('hidden');

    const splide = new Splide(item, {
      autoWidth: true,
      focus: 0,
      perPage: 1,
      omitEnd: true,
      drag: draggable,
      type: 'loop',
      autoplay: true,
      interval: 4000,
    });

    if (item?.getElementsByTagName('li')?.length > 1) {
      const bar = splide.root.querySelector('#cards-module-progress-bar');
      splide.on('mounted move', () => {
        const end = splide.Components.Controller.getEnd() + 1;
        const rate = Math.min((splide.index + 1) / end, 1);
        bar.style.width = String(100 * rate) + '%';
      });
    }

    splide.mount();
  });

};

export default onCardsModuleLoad;
